import { render, staticRenderFns } from "./Pager.vue?vue&type=template&id=685e2094&scoped=true&"
import script from "./Pager.vue?vue&type=script&lang=js&"
export * from "./Pager.vue?vue&type=script&lang=js&"
import style0 from "./Pager.vue?vue&type=style&index=0&id=685e2094&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685e2094",
  null
  
)

export default component.exports